export const mySkills = [
  "CSS BEM convention",
  "CSS Flex",
  "CSS Grid",
  "Error handling",
  "Figma",
  "Git",
  "GitHub Pull Requests & Review",
  "HTML",
  "Immutability",
  "JavaScript",
  "Jira",
  "Local Storage",
  "Media Queries",
  "NPM",
  "Promises, Async/Await",
  "React",
  "React Hooks",
  "React Router",
  "Redux (Toolkit)",
  "Redux-Saga",
  "Redux Hooks",
  "Scrum",
  "Styled Components",
  "Teamwork",
  "Time management",
  "Trello",
  "Working with API (axios, fetch)",
];

export const toLearn = [
  "JS classes",
  "Node.js",
  "Next.js",
  "Tailwind CSS",
  "TypeScript",
  "Unit Testing",
  "Wordpress",
];
